import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "billing-apple-external16218" }
const _hoisted_2 = {
  key: 1,
  class: "billing-apple-external16218__inner"
}

import { nextTick, onBeforeMount, ref } from 'vue'
import type { Raw } from 'vue'
import { useWait } from '@/app/composables/useWait'
import { useRoute } from 'vue-router'

import { createBilling } from '@/models/billing'
import type { BillingView, PlanView } from '@/models/billing'
import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'

import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import SubscribePopup from '@/app/components/billing/SubscribePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingAppleExternal16218',
  setup(__props) {

const route = useRoute()
const wait = useWait()

const paymentForm = ref<InstanceType<typeof SubscribePopup> | null>(null)

const billing = ref<Raw<BillingView> | null>(null)
const plan = ref<Raw<PlanView> | null>(null)

const showRedirectButton = ref(false)

onBeforeMount(async () => {
  await refreshBilling()
})

async function refreshBilling(): Promise<void> {
  wait.start('Loading Billing')
  wait.end('Error Loading Billing')

  try {
    const response = await backend.getBilling()
    billing.value = await createBilling(response)

    // The plan's ID is set in `BillingApplePriceComparison`,
    // from where we open this page. We cast it as any
    // and let `getPlanByID` throw if it's invalid.
    const planID = route.query.plan16218 as any
    plan.value = billing.value.getPlanByID(planID)
  } catch (error) {
    wait.start('Error Loading Billing')
    // The error here is usually NetworkError or Timeout, but
    // we still capture all errors to Sentry to be aware if
    // error rate increases.
    Sentry.withScope(function (scope) {
      scope.setFingerprint(['billing-loading-error'])
      Sentry.captureException(error)
    })
  }
  wait.end('Loading Billing')

  // The payment form is hidden by default (it's rendered
  // inside a popup). We have to wait for the component to
  // be mounted, and then show it.
  await nextTick()
  if (paymentForm.value) {
    paymentForm.value.show()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_LoadingError = _resolveComponent("LoadingError")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(wait).is('Loading Billing'))
      ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
      : (!_unref(wait).is('Error Loading Billing') && billing.value && plan.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (showRedirectButton.value)
              ? (_openBlock(), _createBlock(AppButton, {
                  key: 0,
                  class: "billing-apple-external16218__redirect-button",
                  href: "shortform://?close-browser16218"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("Back to the App", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(SubscribePopup, {
              ref_key: "paymentForm",
              ref: paymentForm,
              class: "billing-apple-external16218__form",
              billing: billing.value,
              plan: plan.value,
              fullscreen16218: true,
              onSubscribed: _cache[0] || (_cache[0] = ($event: any) => (showRedirectButton.value = true))
            }, null, 8, ["billing", "plan"])
          ]))
        : (_openBlock(), _createBlock(_component_LoadingError, { key: 2 }))
  ]))
}
}

})